import axios from 'axios'
import {Message} from 'element-ui'
import router from "@/router";


const service = axios.create({
    baseURL: '/api',
    timeout: 5000
});
/*
 * 设置请求拦截器
 */
/*
 * 设置请求拦截器
 */
service.interceptors.request.use(
    config => {
        config.headers.Authorization = localStorage.getItem('my_token')
        return config
    },
    error => {
        console.log(error)
        return Promise.reject()
    }
)
// /*
//  * 响应拦截器
//  */
// service.interceptors.response.use(
//     response => {
//
//
//         if (response.status === 200) {
//
//             console.log(111111);
//             console.log(response);
//             console.log(123123321);
//
//             return response.data;
//         } else {
//             console.log('eeeeeeeee');
//
//             Promise.reject();
//         }
//     },
//     error => {
//         console.log(error);
//         return Promise.reject();
//     }
// );

/*
 * 响应拦截器
 */
service.interceptors.response.use(
    response => {
        const res = response.data
        if (response.status === 200) {

            if (res.code === 10004) {
                // Message({
                //     message: 'token失效,请重新登录!',
                //     type: 'error',
                //     duration: 2000
                // });

                setTimeout(function () {
                    router.push('/login');
                }, 2000);
            }
            return res
        } else {
            Promise.reject()
        }
    },
    error => {
        console.log(error)
        return Promise.reject()
    }
)


export default service;
